<template>
  <footer class="small text-center mb-4" v-if="authenticated || show">
    Copyright © {{ currentYear }} Grupo IUSA. Todos los Derechos Reservados. <span class="mx-1">·</span>
    <a href="pdf/aviso_privacidad.pdf" class="link-danger" target="_blank">Aviso de Privacidad</a>
  </footer>  
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data(){
    return {
      currentYear: new Date().getFullYear(),
    }
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
    }),
  },
  methods: {},
};
</script>

